import { createBrowserRouter } from "react-router-dom";
import { getRoutes } from "./routes";
import { ErrorBoundary } from "../components/error/ErrorBoundary";
import PageNotFound from "../components/error/PageNotFound";
import AppLayout from "./AppLayout";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <ErrorBoundary />,
    children: getRoutes(),
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);
